import ApiBase from 'Services/Api/ApiBase';

class Documents extends ApiBase {
    route = '/service-users/:user/documents';

    //add delete method
    deleteDocuments = async ( document, user ) => {
        return await this.delete ( {
            route: ':document',
            user: user,
            document: document
        } );
    }

    /**
     * "I have read and understood" the current version of a document.
     *
     * @method markRead
     * @param {string} user The service user's id.
     * @param {string} document
     * @return {Promise<*>}
     */
    markRead = (user, document) => this.post(`/service-users/${user}/documents/${document}/read`, {}, 'read', [200, 201]);

    getFamilyDocuments = async ( user,data ) => {
        return await this.get ( '/service-users/service-users-family/' + user + '/documents/', data );
    }
}
export default new Documents();
